export function getTimezoneOffset(): number {
  return new Date().getTimezoneOffset();
}